// @arch:pure-engine
// Opt-in, deterministic policy: routing itself spends no model tokens.
// Price is not a quality score. Unknown/complex work keeps the chosen model.
import { routeTurn } from './turnRouter.js';

const PROFILES = {
  amplo: { effort: 'high', iterationLimit: 64, maxTokensOut: 64_000, maxCostUsd: 3 },
  rápido: { effort: 'low', iterationLimit: 6, maxTokensOut: 8_000, maxCostUsd: 0.5 },
  equilibrado: { effort: 'med', iterationLimit: 24, maxTokensOut: 32_000, maxCostUsd: 1.5 },
};
function taskTier(task, role, priorTurnTouchedCode, hasAttachments) {
  if (task.length > 2000 || /arquitet|auditor|refator|migra[çc]|research|pesquis|complex|completo|ponta a ponta|end.to.end/i.test(task)) return 'amplo';
  if (!hasAttachments && !priorTurnTouchedCode && task.length < 500 && role === 'chat') return 'rápido';
  return 'equilibrado';
}
function cheaperModel(currentModel, models) {
  const current = models.find((model) => model.id === currentModel);
  if (!current) return currentModel;
  const candidates = models.filter((model) => model.provider === current.provider
    && model.score > 0 && model.score < current.score && model.contextWindow >= current.contextWindow
    && model.capabilities?.includes('tools'));
  candidates.sort((a, b) => a.score - b.score || a.id.localeCompare(b.id));
  return candidates[0]?.id || currentModel;
}
export function decideAutoMode({ text, currentModel, models = [], priorTurnTouchedCode = false, hasAttachments = false }) {
  const task = String(text || '');
  const base = routeTurn({ text: task, priorTurnTouchedCode });
  const tier = taskTier(task, base.role, priorTurnTouchedCode, hasAttachments);
  const selected = tier === 'rápido' ? cheaperModel(currentModel, models) : currentModel;
  return {
    ...base, ...PROFILES[tier], auto: true, model: selected,
    modelTier: tier === 'rápido' ? 'cheap' : 'keep',
    reason: `Auto · ${tier} · ${selected === currentModel ? 'modelo mantido' : 'modelo econômico do mesmo provedor'} · permissões preservadas`,
  };
}

export function autoModeDirective(decision) {
  if (!decision?.auto) return '';
  return '\nModo Auto: escolha ferramentas pelo objetivo; organize tarefas longas em etapas verificáveis. Reuse resultados válidos. Não repita tentativas idênticas. Informe evidência, pendências e limites na entrega.';
}

export function autoModeContext(state, session, attachments) {
  return { autoMode: (state.code.chatModes[session.id] || session.flags?.collaboration_mode) === 'auto', hasAttachments: !!attachments?.length };
}
export function tracksTurnDecision(enabled, decision) { return enabled || decision?.auto; }
export function turnDecisionMetadata(decision, route) {
  return decision && (decision.role !== 'none' || decision.auto) ? { ...decision, modelId: route?.model } : null;
}
export function turnDecisionVisible(router) { return !!router.lastDecision && (router.enabled || router.lastDecision.auto); }
export function turnSystemMessages(system, decision) {
  const content = (system || '') + autoModeDirective(decision);
  return content ? [{ role: 'system', content }] : [];
}
export function turnIterationLimit(decision, voice) {
  return decision?.auto && !voice.voiceMode ? decision.iterationLimit : voice.maxIterations;
}
